<template>
	<div :style="{ height: bodyHeight + 'px' }" class="home m-body">
		<van-image
			width="100%"
			height="1rem"
			:src="require('@/assets/images/m_head.png')"
		></van-image>
		
		<div class="main">
			<div class="info qjc-flex">
				<div class="weather qjc-flex">
					<van-image
						width="1.54rem"
						height="1.7rem"
						:src="weather.img?require('@/assets/images/'+ weather.img +'.png'):''"
					></van-image>
					<dl>
						<dt>{{ weather.temperature }}°C</dt>
						<dd>{{ weather.text }}<span class="place">{{ weather.city }}</span></dd>
					</dl>
				</div>
				<dl class="date qjc-texta-c">
					<dt>{{ time }}</dt>
					<dd class="qjc-fts-22">{{ date }} {{ week }}</dd>
				</dl>
			</div>
			
			<div class="modules">
				<ul class="qjc-clearfix">
					<li @click="to('https://medin.medinhealth.com/#/home/experience?from=yzzx-wap&user=yzzx')" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/yzzx_m_medinhealth.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">健康大数据VIP服务</h4>
					</li>
					<li @click="anruKaixuanSwipe=true" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/yzzx_m_anrukaixuan.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">安儒月子凯旋店</h4>
					</li>
					<li @click="to('https://mp.weixin.qq.com/s/YyrXinQIEaS6r1Q0WB-Rwg')" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/yzzx_m_anru.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">安儒月子中心</h4>
					</li>
					<li @click="anruVideoShow=true" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/yzzx_anru_m_video.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">安儒宝宝护理实拍</h4>
					</li>
				</ul>
			</div>
			
			<div class="health">
				<h3 class="qjc-fts-36">
					健康频道
					<span @click="to('https://m.medinbd.com/#/study')" class="more qjc-ftw-n qjc-fts-24 qjc-fr">查看更多</span>
				</h3>
				
				<van-swipe @change="checkTab" :autoplay="5000" ref="swipe">
					<van-swipe-item v-for="(list,index) in healthList" :key="index">
						<ul v-for="item in list" :key="item.id" class="list qjc-fts-32">
							<li @click="to(item.id?'https://m.medinbd.com/#/study/detail/'+item.id:item.url)">{{ item.title }}</li>
						</ul>
					</van-swipe-item>
				</van-swipe>
				
				<ol class="tabs qjc-flex">
					<li @click="tabClick(index)" v-for="(i,index) in healthList" :key="'tab'+index" :class="{ 'active': index == healthListPage }"></li>
				</ol>
			</div>
			
			<p class="foot qjc-fts-20">
				最终解释权归上海米因大数据科技有限公司所有
			</p>
			
		</div>
		
		<m-footer></m-footer>
		
		<!-- 安儒月子凯旋店轮播 -->
		<div v-if="anruKaixuanSwipe" :style="{ width: bodyHeight+'px', height: '7.5rem' }" class="anru-kaixuan-swipe qjc-fixed">
			<ul class="images" @touchstart="swipeTouchStart" @touchend="swipeTouchEnd" refs="swipes">
				<li v-for="i in swipeCount" @click="checkSwipe(i)" :class="{ active: swipeCurrent==i }" :key="i" :ref="'swipe'+i">
					<img :src="'https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/09/22/anrukaixuan'+ i +'.png'" class="qjc-wid-100 qjc-hei-100" alt="">
				</li>
			</ul>
			<!-- 导航圆点 -->
			<ol class="navs">
				<li v-for="i in swipeCount" @click="swipeCurrent = i" :class="{ active: swipeCurrent==i }" :key="i"></li>
			</ol>
			<!-- 关闭按钮 -->
			<img @click="anruKaixuanSwipe=false" class="close qjc-absolute" src="../../../../assets/images/swipe_close.png" alt="关闭">
		</div>
		
		<!-- 安儒宝宝护理实拍视频弹窗 -->
		<div v-if="anruVideoShow" class="video-box qjc-fixed qjc-wid-100 qjc-hei-100">
			<video width="100%" height="auto" autoplay loop controls src="https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/09/17/anruyuezi.mp4" ref="anruVideo">
				您的浏览器不支持video标签
			</video>
			
			<img @click="anruVideoShow = false" class="close" src="../../../../assets/images/swipe_close.png" alt="视频关闭按钮">
		</div>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Image, Swipe, SwipeItem, Toast } from 'vant'
	Vue.use(Image)
	   .use(Swipe)
	   .use(SwipeItem)
	   .use(Toast);
	
	import MFooter from '@/components/m/Footer'
	
	import { getWeatherInfo, getHealth } from '@/utils/axios'
	
	export default{
		name: 'yzzxmHome',
		data() {
			return {
				bodyHeight: document.documentElement.clientHeight,
				
				weather: {
					img: '',
					text: '--',
					temperature: '--',
					city: '--'
				},//天气状况
				
				date: '--',
				time: '--',
				week: '--',
				
				healthList: [
					{ title: '月是中秋明 情是安儒浓，安儒秋日晚宴招募', url: 'https://mp.weixin.qq.com/s/UMCD3ggM4Bu-llOk4DJr_Q' },
					{ title: '喜讯丨安儒月子中心番禺店喜迎首位宝妈入住！', url: 'https://mp.weixin.qq.com/s/cs5PTlFBi_pgQwmW8nyT5Q' },
					{ title: '番禺店月子房空前火爆！9月到11月的特价房还可预订！先到先得！', url: 'https://mp.weixin.qq.com/s/ocrk6Uc5WjwBdkEzXK2B0Q' },
					{ title: '活动回顾丨这个孕期彩绘炫“腹”活动太好玩了吧！', url: 'https://mp.weixin.qq.com/s/jiPDhS-tfHE6yk6jpsL7SQ' },
					{ title: '安儒手工课堂丨慈母手中线，亲手为宝宝DIY小礼物', url: 'https://mp.weixin.qq.com/s/uKf55PxXEzqh6QJdRAcFqg' },
					{ title: '活动招募丨孕妈DIY肚皮彩绘，一起来高调炫“腹”', url: 'https://mp.weixin.qq.com/s/sj7sSPwgf6wglW1N2uQZ5Q' },
					{ title: '紧张？焦虑？抑郁？孕后心理保健很重要！', url: 'https://mp.weixin.qq.com/s/61maHWvdbTMFHTkLbE6LkQ' },
					{ title: '逆市开业丨安儒月子中心番禺店就是这么牛！', url: 'https://mp.weixin.qq.com/s/bSDfDRWKeiej0JYSg8gOng' },
					{ title: '安儒月子中心番禺店开业送豪礼，月子房免费住！', url: 'https://mp.weixin.qq.com/s/Pz4M9uSvHIeQwpDtqYrTaA' },
					{ title: '新店曝光|把更好的月子服务，带到您身边', url: 'https://mp.weixin.qq.com/s/YyrXinQIEaS6r1Q0WB-Rwg' },
					{ title: '【新店开业】番禺店除甲醛现场曝光，不放过任何死角！', url: 'https://mp.weixin.qq.com/s/KTLeEAWZJNKmc1ZnOT_hJg' },
					{ title: '感谢信|来自妈妈们的“表白”', url: 'https://mp.weixin.qq.com/s/EaNQYSrhbQF6-dhaNIbg6A' },
					{ title: '热烈祝贺安儒月子中心当选广东省家政服务标准化技术委员会委员', url: 'https://mp.weixin.qq.com/s/WQGSGYJJxc0mjPGY4DDmSQ' },
					{ title: '产后康复除了关注身体更要关注心理', url: 'https://mp.weixin.qq.com/s/ZJpuzqZlCB6LB4V2f4kwiQ' },
					{ title: '孕早期知识|惹人烦的孕吐该拿它怎么办', url: 'https://mp.weixin.qq.com/s/TRlyfPgrFLaomWyGIlMCrw' },
					{ title: '孕晚期和分娩前这些注意事项孕妈们要尤为注意！', url: 'https://mp.weixin.qq.com/s/LUypHPOEtFvsP0MBLqcWFA' },
				],// 默认写死文章
				healthListPage: 0,
				
				anruVideoShow: false,// 安儒宝宝护理实拍视频显示
				anruKaixuanSwipe: false,// 安儒月子凯旋店轮播
				
				swipeCount: 15,// 轮播图个数
				swipeCurrent: 1,// 当前展示图
				timer: '',// 轮播定时器
				speed: 3000,// 轮播速率
				swipeTouchS: 0,// 开始触摸位置
				
			}
		},
		watch: {
			anruKaixuanSwipe(val) {// 展示图片时开始轮播
				if(val){
					this.$nextTick(() => {
						this.swipeInit();
						this.timer = setInterval(this.timerFunc, this.speed);
					})
				}else{// 关闭后初始化
					clearInterval(this.timer);
				}
			},
			swipeCurrent(val) {
				if(val > this.swipeCount){
					this.swipeCurrent = 1;
				}else if(val < 1){
					this.swipeCurrent = this.swipeCount;
				}
				this.swipeInit();
			}
		},
		components: {
			MFooter
		},
		mounted() {
			this.$nextTick(() => {
				this.getWeather();
				this.getTime();
				
				this.getHealthList();
				
			})
		},
		methods: {
			// 初始化swipe
			swipeInit() {
				this.$nextTick(() => {
					// 存储当前变化swipe标志用以清除其他swipe style
					let updateArr = [];// 默认包含当前展示
					for(var i=1;i<=2;i++){
						// 右侧
						var rIndex = ((this.swipeCurrent+i)>this.swipeCount?(this.swipeCurrent+i-this.swipeCount):(this.swipeCurrent+i)),
							right = this.$refs['swipe'+rIndex][0];
						right.style.transform = 'translate3d('+ 3*i +'rem, 0, -'+ 3*i +'rem)rotateY(-'+ 15*i +'deg)';
						right.style.zIndex = -i;
						updateArr.push(rIndex);
						
						// 左侧
						var lIndex = (this.swipeCurrent-i>0?(this.swipeCurrent-i):this.swipeCount+(this.swipeCurrent-i)),
							left = this.$refs['swipe'+lIndex][0];
						left.style.transform = 'translate3d(-'+ 3*i +'rem, 0, -'+ 3*i +'rem)rotateY('+ 15*i +'deg)';
						left.style.zIndex = -i;
						updateArr.push(lIndex);
					}
					// 清除除当前展示五个以外的swipe样式
					for(var r=1;r<=this.swipeCount;r++){
						if(updateArr.indexOf(r) == -1){
							this.$refs['swipe'+r][0].style = '';
						}
					}
				});
			},
			// 轮播
			timerFunc() {
				++this.swipeCurrent;
			},
			// 开始触摸
			swipeTouchStart(e) {
				this.swipeTouchS = e.targetTouches[0].screenY;
				// 触摸时停止轮播
				clearInterval(this.timer);
			},
			// 结束触摸
			swipeTouchEnd(e) {
				var diff = e.changedTouches[0].screenY - this.swipeTouchS;// 触摸开始和结束间距
				// 间距超过一定位置切换
				if(Math.abs(diff) > 5){
					diff > 0?--this.swipeCurrent:++this.swipeCurrent;
				}
				// 重启轮播
				this.timer = setInterval(this.timerFunc, this.speed);
			},
			// 点击切换swipe
			checkSwipe(i) {
				// 停止轮播
				clearInterval(this.timer);
				var way = '';// 0: --, 1: ++
				if(i > this.swipeCurrent){
					if(this.swipeCurrent < 3 && i > (this.swipeCount - 2)){
						--this.swipeCurrent;
						way = '--';
					}else{
						++this.swipeCurrent;
						way = '++';
					}
				}else if(i < this.swipeCurrent){
					if(this.swipeCurrent > (this.swipeCount - 2) && i < 3){
						++this.swipeCurrent;
						way = '++';
					}else{
						--this.swipeCurrent;
						way = '--';
					}
				}
				// 切换个数大于一，半秒间隔
				if(this.swipeCurrent >= 0 && (this.swipeCurrent <= (this.swipeCount+1)) && this.swipeCurrent != i){
					setTimeout(() => {
						if(way == '++'){
							++this.swipeCurrent;
						}else{
							--this.swipeCurrent;
						}
						// 重启轮播
						this.timer = setInterval(this.timerFunc, this.speed);
					}, 500);
				}else{
					// 重启轮播
					this.timer = setInterval(this.timerFunc, this.speed);
				}
			},
			
			// 获取天气信息 参数：调用api下标
			getWeather(apiListIndex) {
				var getWeatherTime = localStorage.getItem('getWeatherTime'),
					differ = new Date().getTime() - (getWeatherTime?getWeatherTime:0);
				var res = '';
				if(differ > (30 * 60 * 1000)){
					var index = apiListIndex?apiListIndex:0;
					
					// 三条线路
					if(index < 3){
						getWeatherInfo(index).then(data => {
							console.log(data);
							res = data;
							if(res.wea_img){
								
								// 存储接口调取时间，存储数据，三十分钟后再次调取
								localStorage.setItem('getWeatherTime', new Date().getTime());
								localStorage.setItem('weatherInfo', JSON.stringify(res));
								
								this.showWeather(res);
							}else{
								this.getWeather(++index);
							}
							
						})
					}else{
						alert('天气信息获取失败');
					}
					
				}else{
					res = JSON.parse(localStorage.getItem('weatherInfo'));
					if(res.wea_img){
						this.showWeather(res);
					}else{
						localStorage.removeItem('weatherInfo');
					}
				}
				
			},
			//展示天气情况
			showWeather(res){
				// 天气状况
				this.weather.img = res.wea_img;
				this.weather.text = res.wea;// 描述
				this.weather.temperature = res.tem;// 实时气温
				this.weather.city = res.city
				
				// 日期
				// this.date = res.date.split('-').join('/');
				// this.week = res.week;
				
				// 隔三十分钟调取一次
				var that = this;
				setTimeout(() => {
					that.getWeather();
				}, 30 * 60 * 1000);
			},
			
			// 获取健康频列表
			getHealthList(){
				getHealth().then(res => {
					// console.log(res);
					
					if(res.status == 1){
						
						// 三条一页
						var list = this.healthList.concat(res.data.data),
							forList = [];
						for(var i=0;i<list.length;i++){
							var last = forList[forList.length-1];
							if(last && last.length < 3){
								last.push(list[i]);
							}else{
								forList.push([list[i]]);
							}
						}
						this.healthList = forList;
						
					}else{
						alert(res.msg);
					}
				});
			},
			//指示器
			checkTab(index) {
				this.healthListPage = index;
			},
			// 指示器时间
			tabClick(index) {
				this.$refs.swipe.swipeTo(index);
			},
			
			// 获取时间
			getTime() {
				// 接口无时间,获取当前时间
				var now = new Date();
				this.time = (now.getHours()<10?'0'+now.getHours():now.getHours()) + ':' + (now.getMinutes()<10?'0'+now.getMinutes():now.getMinutes());
				
				// 时间校准(毫秒校准)
				var speed = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
				
				// 日期
				this.date = now.getFullYear() + '/' + (now.getMonth()+1) + '/' + now.getDate();
				var weeks = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'];
				this.week = weeks[now.getDay()];
				
				// 周期性一分钟一次
				setTimeout(() => {
					this.getTime();
				}, speed);
				
			},
			
			// 跳转链接
			to(url) {
				window.location.href = url;
			}
			
		}
	}
</script>

<style scoped>
	/* 自定义指示器只能隐藏,否则在ios上会出现文字卡顿停留 */
	.health >>> .van-swipe__indicators{
		visibility: hidden;
	}
</style>
<style lang="scss" scoped>
	.home{
		color: #5FD6FF;
		padding-top: 0.08rem;
		padding-bottom: 1.9rem;
		
		.main{
			margin: 0.24rem;
			
			&>div{
				background: linear-gradient(180deg,rgba(49,92,147,0.5) 0%,rgba(22,47,90,0.5) 100%);
				border-radius: 0.06rem;
				margin-bottom: 0.24rem;
			}
			
			.info{
				justify-content: space-between;
				align-items: center;
				
				.weather{
					justify-content: flex-start;
					align-items: center;
					
					dl{
						margin-left: 0.08rem;
						
						dt{
							font-size: 0.48rem;
							line-height: 0.48rem;
							font-weight: 400;
						}
						dd{
							font-size: 0.28rem;
							line-height: 0.28rem;
							margin-top: 0.16rem;
							
							.place{
								margin-left: 0.2rem;
							}
						}
					}
				}
				.date{
					padding-right: 0.32rem;
					
					dt{
						font-size: 0.72rem;
						line-height: 0.72rem;
					}
					dd{
						line-height: 0.22rem;
						margin-top: 0.16rem;
					}
				}
			}
			
			.modules{
				color: #E3ECFF;
				padding: 0.32rem 0.11rem 0;
				
				li{
					width: 50%;
					padding: 0 0.11rem;
					margin-bottom: 0.24rem;
					
					h4{
						margin-top: 0.12rem;
					}
				}
			}
			
			.health{
				h3{
					font-weight: 500;
					line-height: 0.95rem;
					border-bottom: 0.01rem solid #3D5E90;
					padding: 0 0.32rem;
					
					.more{
						position: relative;
						margin-right: 0.18rem;
						
						&::after{
							position: absolute;
							content: '';
							top: 50%;
							right: -0.18rem;
							width: 0.16rem;
							height: 0.16rem;
							border-top: 0.01rem solid #5FD6FF;
							border-right: 0.01rem solid #5FD6FF;
							transform: translateY(-50%)rotateZ(45deg);
						}
					}
				}
			
				.list{
					padding: 0 0.32rem;
					
					li{
						display: flex;
						align-items: center;
						position: relative;
						height: 1.55rem;
						line-height: 0.4rem;
						
						&::after{
							content: '';
							position: absolute;
							bottom: 0;
							left: 0.09rem;
							right: 0.09rem;
							border-bottom: 0.01rem dashed #3D5E90;
						}
					}
				}
				
				.tabs{
					height: 0.85rem;
					justify-content: center;
					align-items: center;
					
					li{
						width: 0.16rem;
						height: 0.16rem;
						border-radius: 0.02rem;
						background-color: #325D6C;
						margin: 0 0.12rem;
						
						&.active{
							background-color: #86D2ED;
						}
					}
				}
					
			}
			
			.foot{
				color: #6E7EA0;
				margin-top: 0.32rem;
				text-align: center;
			}
			
		}
		
		.anru-kaixuan-swipe{
			display: flex;
			align-items: center;
			justify-content: center;
			top: 50%;
			left: 50%;
			right: 0;
			bottom: 0;
			background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
			background-size: 100% 100%;
			transform: translate(-50%,-50%)rotateZ(90deg);
			overflow: hidden;
			z-index: 9999;
			
			.images{
				position: relative;
				width: 6.015rem;
				height: 4.025rem;
				margin-top: -0.4rem;
				perspective: 10rem;
				
				li{
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					transform: translate3d(0, 0, -10rem)rotateY(0);
					z-index: -999;
					transition: all .4s;
					
					&.active{
						transform: translate3d(0, 0, 0)rotateY(0) !important;
						z-index: 999 !important;
						
					}
					&:not(.active)::before{
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						content: '';
						background-image: linear-gradient(to right, rgba(34, 34, 34, 0) 0%, rgba(34, 34, 34, .9) 33.4%, rgba(34, 34, 34, .9) 66.7%, rgba(34, 34, 34, 0) 101%);
						transition: all .4s;
					}
				}
			}
			
			.navs{
				display: flex;
				justify-content: center;
				position: absolute;
				top: 50%;
				left: 0;
				right: 0;
				margin-top: 2.1rem;
				
				li{
					width: 0.12rem;
					height: 0.12rem;
					border-radius: 50%;
					background-color: rgba(255,255,255,.5);
					margin: 0 0.08rem;
					
					&.active{
						background-color: rgba(255,255,255,.9);
					}
				}
			}
		
			.close{
				top: 0.32rem;
				right: 0.32rem;
				width: 0.56rem;
				height: 0.56rem;
			}
		}
		
		.video-box{
			display: flex;
			align-items: center;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: rgba(0,0,0,.8);
			
			.close{
				position: absolute;
				top: 0.32rem;
				right: 0.32rem;
				width: 0.56rem;
				height: 0.56rem;
			}
		}
		
	}
</style>
